import React from 'react';
import PropTypes from 'prop-types';
import CheckBox from 'mineral-ui/Checkbox';

const propTypes = {
  checkableButton: PropTypes.bool,
};
const defaultProps = {
  checkableButton: false,
};

export default function CheckableButton({ checkableButton, ...rest }) {
  const CheckableTheme = (theme) => {
    const defaultPaddingSpace = theme.space_inset_sm.replace(/[^\d.-]/g, '');
    const borderSpace = `${0.1 * defaultPaddingSpace}em`;
    const computedPaddingSpace = `${0.9 * defaultPaddingSpace}em`;
    return {
      fontWeight: checkableButton ? theme.fontWeight_semiBold : 'normal',
      border: checkableButton ? `${borderSpace} solid ${theme.borderColor}` : 'none',
      padding: checkableButton ? computedPaddingSpace : theme.space_inset_sm,
      borderRadius: theme.borderRadius_1,
      ':hover': {
        borderColor: theme.borderColor_theme_hover,
      },
    };
  };
  return (
    <CheckBox
      {...rest}
      rootProps={{ css: CheckableTheme }}
    />
  );
}

CheckableButton.propTypes = propTypes;
CheckableButton.defaultProps = defaultProps;
